/*
 * Copyright (c) Nexign, JSC, 2019.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @version 1.1.0
 * @since 1.1.0
 */

import { createSelector, OutputSelector } from 'reselect';

import { IRootReducer } from '../../reducers/rootReducer';
import { ILoaderReducer } from './loaderReducer';

const selectLoader = (state: IRootReducer): ILoaderReducer => state.loader;

export const makeSelectLoaderIsLoading = ():
    OutputSelector<IRootReducer, boolean, (state: ILoaderReducer) => boolean> =>
    createSelector(
        selectLoader,
        (state: ILoaderReducer) => state.showLoader,
    );


export const makeSelectLoaderText = ():
    OutputSelector<IRootReducer, string, (state: ILoaderReducer) => string> =>
    createSelector(
        selectLoader,
        (state: ILoaderReducer) => state.textLoader,
    );
